"use strict";

var _extends = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/extends");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var RadixPopover = _interopRequireWildcard(require("@radix-ui/react-popover"));
var _popover = require("./popover.tokens");
var _globalTokens = require("../../../shared/global-tokens");
var _jsxRuntime = require("react/jsx-runtime");
var ArrowSvg = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", _objectSpread({
    width: "24",
    height: "12",
    viewBox: "0 0 24 12",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      width: "24",
      height: "2",
      fill: _popover.tokens.background.color
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
      points: "0 0 12 10 24 0",
      stroke: _globalTokens.globalColor.border.separator,
      strokeWidth: "1",
      strokeLinecap: "butt",
      fill: _popover.tokens.background.color,
      strokeLinejoin: "round"
    })]
  }));
});
var StyledArrow = (0, _styledComponents.default)(RadixPopover.Arrow).withConfig({
  displayName: "Arrow__StyledArrow",
  componentId: "sc-gvmesp-0"
})(["width:24px;height:12px;position:relative;top:-1px;"]);
var Arrow = function Arrow(_ref) {
  var other = _extends({}, _ref);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledArrow, _objectSpread({
    asChild: true
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ArrowSvg, {})
  }));
};
exports.Arrow = Arrow;